import React from 'react';
import styled from 'styled-components';
import { P90InfoHover } from '@hud/web-components/src/Hud/P90InfoHover/P90InfoHover';

const Container = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 6px;
`;

export default function P90ColumnHeader() {
  return (
    <Container>
      Dur P90
      <P90InfoHover />
    </Container>
  );
}
